module.exports = __webpack_public_path__ + "static/img/case1.3cc94c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case1.png
// module id = ehsu
// module chunks = 1